import script from "./WithdrawTotals.vue?vue&type=script&setup=true&lang=ts"
export * from "./WithdrawTotals.vue?vue&type=script&setup=true&lang=ts"

import "./WithdrawTotals.vue?vue&type=style&index=0&id=8d8dfa84&scoped=true&lang=css"

import exportComponent from "/Users/jason/u/acsi-ui-balancer-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8d8dfa84"]])

export default __exports__